import React, { memo } from 'react';
import Menu from '@material-ui/core/Menu';
import remove from 'lodash/remove';
import cn from 'classnames';
import EditIcon from '@material-ui/icons/Edit';
import css from './LangSelect.module.scss';
import { i18n, useTranslation } from '../../src/i18n';
import { TP } from '../../constants/consts';
import { changeLanguageForUrl } from '../../utils/common';
import usePermissions from '../../utils/permissions';

require('dotenv').config();

const LangSelect = () => {
  const languages = process.env.FRONTBASE_LANGUAGES.split(',');
  const { t } = useTranslation();
  const [selectedLang, setSelectedLang] = React.useState('');
  const [editMode, setEditMode] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { isTranslator } = usePermissions();

  const orderLangs = () => {
    remove(languages, l => l === i18n.language);
    return languages.sort();
  };

  const [langs, setLangs] = React.useState(orderLangs());

  React.useEffect(() => {
    setSelectedLang(i18n.language.toLowerCase());
    setLangs(orderLangs());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  React.useEffect(() => {
    if (isTranslator) {
      document.addEventListener('lokalise-on-auth-state-change', event => {
        const { authenticated } = event?.detail;
        if (authenticated && selectedLang !== 'keys') {
          handleRedirect('keys');
        }
        setEditMode(authenticated);
      });
    }
  }, [isTranslator]);

  const handleClick = language => {
    if (editMode) {
      setSelectedLang(language);
      document.dispatchEvent(new CustomEvent('lokalise-update-locale', { detail: language }));
    } else {
      handleRedirect(language);
    }
    closeLanguages();
  };

  const handleRedirect = language => {
    // get the last parameter from the url
    const redirectUrl = changeLanguageForUrl(language, window.location.href);
    if (!redirectUrl) {
      // close languages as the redirection didn't  work
      return closeLanguages();
    }
    // redirect to the new url
    window.location.replace(redirectUrl);
  };

  const openLanguages = event => setAnchorEl(event.currentTarget);
  const closeLanguages = () => setAnchorEl(null);
  return selectedLang ? (
    <div className={css.languageWrapper}>
      <div className={cn(css.country)} onClick={openLanguages}>
        {editMode && <EditIcon color="primary" fontSize="small" />}
        <span className={cn(css.flag, css[`lang_${selectedLang.toLowerCase()}`])}></span>
        <span className={css.flagName}>{selectedLang.toUpperCase()}</span>
      </div>

      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={closeLanguages}>
        <div className={css.languageDropdown}>
          <div className={css.langTitle}>{t(`${TP}.SELECT_LANGUAGE`)}</div>
          <div className={css.dropdownContent}>
            {langs.map(language => (
              <div className={css.country} onClick={() => handleClick(language)} key={`language-${language}`}>
                <span className={cn(css.flag, css[`lang_${language.toLowerCase()}`])}></span>
                <span className={css.flagName}>{language.toUpperCase()}</span>
              </div>
            ))}
          </div>
        </div>
      </Menu>
    </div>
  ) : null;
};

export default memo(LangSelect);
